import { useContext, useEffect, useState } from "react"
import { AppContext } from "../../context/context"
import UiButton1 from "../../components/ui_button1"
import UiSpinner from "../../components/ui_spinner"
import jsonToCsvExport from "json-to-csv-export";
import moment from "moment";

const EditorExport = () => {

    let {
        qouteDelimiter,
        isNumber,
        queryAddon,
        brand,
        fetchDataV2
    } = useContext(AppContext)

    let [count, setCount] = useState(0)
    let [load, setLoad] = useState(false)

    const countData = async () => {
        if (!brand.brand_entity_id) return false

        setLoad(true)

        try {
            let resp = await fetchDataV2("EXPORT_COUNT", {
                brand_entity_id: brand.brand_entity_id,
                queryAddon: queryAddon
            }, "/bigquery-sql-v2")

            resp = resp.map(x => x.counted)[0]
            setCount(resp)
        }
        catch (err) {
            return
        }
        finally {
            setLoad(false)
        }
    }

    const downloadDataHandler = async () => {
        if (!brand.brand_entity_id) return false

        setLoad(true)
        let limit = 3000
        let parts = Math.ceil(count / limit)
        let queries = []

        let sqler = (offset) => {
            return fetchDataV2("EXPORT_PRODUCTS", {
                brand_entity_id: brand.brand_entity_id,
                queryAddon: queryAddon,
                limit: limit,
                offset: offset
            }, "/bigquery-sql-v2")
        }

        for (let i = 0; i < parts; i++) {
            queries.push(() => sqler(i * limit))
        }

        try {
            let resp = await Promise.all(queries.map(x => x()))
            let json = [].concat(...resp)
            json = json.map(x => {
                let str_id = x["Product ID STR"]
                delete x["Product ID STR"]
                return {
                    ...x,
                    "Product ID": "'" + qouteDelimiter(str_id, 1)
                }
            })
            jsonToCsvExport({ data: json, filename: `${brand.brand.replace(/ /g, "_")}_${moment().format("YYYYMMDDhhss")}.csv` })
        }
        catch (err) {
            return
        }
        finally {
            setLoad(false)
        }
        return
    }

    useEffect(() => {
        countData()
    }, [])

    if (load) return (
        <div className="d-flex justify-content-center h-100">
            <UiSpinner />
        </div>
    )

    return (
        <>
            <div className="d-flex flex-column">
                <p className="fs-4 mb-0">Export</p>
                <div>
                    <p className="poppins">
                        This will download {isNumber(count)} ASINs.&nbsp;
                        Use this file as a template for bulk product data imports.&nbsp;
                        Do not modify the first six columns, as changes may cause data loading errors or skipped ASINs.
                    </p>
                </div>
                {count > 0 &&
                    <UiButton1 text="Download" submit={downloadDataHandler} />
                }
            </div>
        </>
    )
}

export default EditorExport